import { render, staticRenderFns } from "./showInfoDialog.vue?vue&type=template&id=390c9e4c&scoped=true&"
import script from "./showInfoDialog.vue?vue&type=script&lang=js&"
export * from "./showInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./showInfoDialog.vue?vue&type=style&index=0&id=390c9e4c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390c9e4c",
  null
  
)

export default component.exports